import { render, staticRenderFns } from "./OrderReviewReadonly.vue?vue&type=template&id=1e07eeb6"
import script from "./OrderReviewReadonly.vue?vue&type=script&lang=js"
export * from "./OrderReviewReadonly.vue?vue&type=script&lang=js"
import style0 from "./OrderReviewReadonly.vue?vue&type=style&index=0&id=1e07eeb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports